export default {
  path: '/design_file_types',
  name: 'design_file_types',
  component: () => import('../components/designfiletype/Layout'),
  redirect: { name: 'DesignFileTypeList' },
  meta: {
    breadcrumb: 'designfile.designfiletypes',
  },
  children: [
    {
      name: 'DesignFileTypeList',
      path: '',
      component: () => import('../views/designfiletype/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'DesignFileTypeCreate',
      path: 'new',
      component: () => import('../views/designfiletype/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'DesignFileTypeUpdate',
      path: ':id/edit',
      component: () => import('../views/designfiletype/Update'),
      meta: {
        breadcrumb: 'designfile.designfiletype',
      },
    },
    {
      name: 'DesignFileTypeShow',
      path: ':id',
      component: () => import('../views/designfiletype/Show'),
      meta: {
        breadcrumb: 'designfile.designfiletype',
      },
    }
  ]
};
